import { type Locale } from "date-fns";

import {
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
  SupportedLocale,
} from "./constants";
import { getUserLocale } from "./getUserLocale";

const isSupportedLocale = (locale: string): locale is SupportedLocale =>
  locale in SUPPORTED_LOCALES;

export const getDateFnsLocale = (locale: string = getUserLocale()): Locale => {
  if (isSupportedLocale(locale)) {
    return SUPPORTED_LOCALES[locale].dateFnsLocale;
  }

  // getUserLocale can resolve to a bare i18n language code (e.g. "ja"), so fall
  // back to the first supported locale sharing that language.
  const language = locale.split("-")[0];
  const match = (Object.keys(SUPPORTED_LOCALES) as SupportedLocale[]).find(
    (supported) => supported.startsWith(language)
  );

  return SUPPORTED_LOCALES[match ?? DEFAULT_LOCALE].dateFnsLocale;
};
